import { SvgContainer, SvgLine } from "../../../svg_container/js/svg_container";
// interfaces
import { VideoItem } from "../posters";
import { AllDots, Point, getThemeColour } from "../../data/map_data";
import {
  getPointFromId,
  getSVGLineData,
  getThemedConnections,
  getThemeForLineId,
} from "./getters";

let svgConnectedPeople: SvgContainer;

const initLines = () => {
  svgConnectedPeople = new SvgContainer({
    elId: "svgLinesDynamic",
    className: "svg-lines__container svg-lines--theme",
    svgLines: [],
  });
};

/* lines utils */
const drawBackgroundLines = (dotData: AllDots) => {
  new SvgContainer({
    elId: "svgLines",
    className: "svg-lines__container svg-lines--default",
    svgLines: getSVGLineData(dotData),
  });
};

const drawDynamicLines = (
  selectedPerson: VideoItem,
  dotData: AllDots,
  currentTheme: string
) => {
  const svgLines: SvgLine[] = getThemedConnections(
    selectedPerson,
    dotData,
    currentTheme
  );
  svgConnectedPeople.clearLines();
  svgConnectedPeople.addLines(svgLines);
};

const showThemeConnectionLines = (
  people: VideoItem[],
  dotsData: AllDots,
  selectedTheme: string
) => {
  //for each line
  let themedLines: SvgLine[] = [];
  dotsData.lines.forEach((line) => {
    const id = line.lineId;
    const points: Point[] = line.pointIds.map((pointId) =>
      getPointFromId(pointId, dotsData.points)
    );
    let matchedTheme = getThemeForLineId(id, people);
    if (selectedTheme === "all" || selectedTheme === matchedTheme)
      themedLines.push({ id, points, colour: getThemeColour(matchedTheme) });
  });
  svgConnectedPeople.addLines(themedLines);
};

const clearThemeConnectionLines = () => {
  svgConnectedPeople.clearLines();
};

export {
  initLines,
  drawBackgroundLines,
  drawDynamicLines,
  showThemeConnectionLines,
  clearThemeConnectionLines,
};
